import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {StatusCallModel} from '../../../model/status-calls/status-call.model';
import {StatusCallsPageHooks} from './status-calls-page-hooks';

export type StatusCallsPageState = {
  calendarRange: { from: string, to: string }
  setCalendarRange: (range: { from: string, to: string }) => void
  calendarCalls: StatusCallModel[]
  refreshCalendar: () => Promise<void>

  selectedCall: StatusCallModel | null
  setSelectedCall: (call: StatusCallModel | null) => void
  isDrawerOpen: boolean
  setDrawerOpen: (value: boolean) => void

  isScheduleModalOpen: boolean
  setScheduleModalOpen: (value: boolean) => void
  prefilledScheduleAt: string | null
  setPrefilledScheduleAt: (value: string | null) => void

  isAddHoursModalOpen: boolean
  setAddHoursModalOpen: (value: boolean) => void

  translateLocal: (key: string, params?: Record<string, unknown>) => string
  translate: (key: string, params?: Record<string, unknown>) => string
};

const todayIso = (offsetDays: number): string => {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  return d.toISOString().slice(0, 10);
};

export const useStatusCallsPageState = (): StatusCallsPageState => {
  const {t} = useTranslation();

  const [calendarRange, setCalendarRange] = useState<{ from: string, to: string }>({
    from: todayIso(-7),
    to: todayIso(28),
  });
  const [calendarCalls, , refreshCalendar] = StatusCallsPageHooks.useCalendarCalls(calendarRange.from, calendarRange.to);

  const [selectedCall, setSelectedCall] = useState<StatusCallModel | null>(null);
  const [isDrawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [isScheduleModalOpen, setScheduleModalOpen] = useState<boolean>(false);
  const [prefilledScheduleAt, setPrefilledScheduleAt] = useState<string | null>(null);
  const [isAddHoursModalOpen, setAddHoursModalOpen] = useState<boolean>(false);

  return {
    calendarRange,
    setCalendarRange,
    calendarCalls,
    refreshCalendar,
    selectedCall,
    setSelectedCall,
    isDrawerOpen,
    setDrawerOpen,
    isScheduleModalOpen,
    setScheduleModalOpen,
    prefilledScheduleAt,
    setPrefilledScheduleAt,
    isAddHoursModalOpen,
    setAddHoursModalOpen,
    translateLocal: (key, params) => t(`status-calls-page.${key}`, params ?? {}),
    translate: (key, params) => t(key, params ?? {}),
  };
};
